import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtZWRpY2FsJTIwY2xpbmljJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgzMDAyMjIxfDA&ixlib=rb-4.1.0&q=85";

const points = [
  "Multi-disciplinary team collaborating on every case",
  "Standardized assessments and measurable progress goals",
  "Play-based, child-led sessions in a modern facility",
  "Parents as partners — regular reviews and home programs",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-20 bg-[#F8FAFC] border-y border-[#E2E8F0] py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -inset-3 rounded-2xl bg-white border border-[#E2E8F0] -z-10" />
            <img
              src={ABOUT_IMG}
              alt="Modern child development center interior"
              className="w-full aspect-[5/4] object-cover rounded-xl"
              data-testid="about-image"
            />
          </div>
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF]">
              About SHUNYA CDC
            </div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0A192F] tracking-tight">
              A clinical approach with a human touch.
            </h2>
            <p className="mt-4 text-[#475569] leading-relaxed">
              Founded in Jaipur with a simple belief — that every child
              deserves a team that understands them fully — SHUNYA brings
              together pediatric therapists, psychologists and educators under
              one roof. We combine international best-practices with warm,
              individualized care.
            </p>
            <ul className="mt-6 space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-[#0055FF] mt-0.5" />
                  <span className="text-[#0F172A]">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
